import { render, staticRenderFns } from "./PurchaseListIcon.vue?vue&type=template&id=f13462dc&scoped=true"
import script from "./PurchaseListIcon.vue?vue&type=script&lang=ts"
export * from "./PurchaseListIcon.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseListIcon.vue?vue&type=style&index=0&id=f13462dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13462dc",
  null
  
)

export default component.exports